<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :tableTotal="tableTotal"
      :loading="loading"
      :disabled="disabled"
      @openEditFormDialog="openEditFormDialog"
      @reload="reload"
    >
      <page-header
        ref="header"
        slot="header"
        :disabled="disabled"
        :shipmentCode="shipmentCode"
        @query="loadData"
        @addShipmentContainer="LCLVisible = true"
      />
    </page-main>

    <EditFormDialog
      :visible.sync="editFormDialogOptions.visible"
      :title="editFormDialogOptions.title"
      :disabled="editFormDialogOptions.disabled"
      :shipmentCode="shipmentCode"
      :shipmentContainerCode="editFormDialogOptions.code"
      @reload="reload"
    />

    <LCLDialog
      ref="lcl"
      :visible.sync="LCLVisible"
      :title="$l('INDEX.dialog_title_lcl') || 'FCL 整箱/LCL 拼箱'"
      :shipmentCode="shipmentCode"
      @confirm="onLCLConfirm"
      @reload="reload"
      isAdd
    />
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import PageMain from './main'
import PageHeader from './header'
import EditFormDialog from '../edit-form/dialog.vue'
import LCLDialog from '../lcl'
export default {
  components: {
    PageHeader,
    PageMain,
    EditFormDialog,
    LCLDialog,
  },
  mixins: [EditLoading],
  props: {
    shipmentCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      tableTotal: {},
      editFormDialogOptions: {
        visible: false,
        title: '',
        disabled: false,
        code: '',
      },
      LCLVisible: false,
    }
  },
  methods: {
    reload() {
      this.$refs.header.query()
    },
    loadData(form) {
      this.loadTableMainData(form)
      this.loadTableTotalData(form)
    },
    loadTableMainData(form) {
      this.loading = true
      this.$api
        .shipmentContainerListApi({
          shipmentCode: this.shipmentCode,
          ...form,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    loadTableTotalData(form) {
      this.$api
        .shipmentContainerListSumApi({
          shipmentCode: this.shipmentCode,
          ...form,
        })
        .then((res) => {
          this.tableTotal = res.body
        })
        .catch(() => {})
    },
    openEditFormDialog({ type = '', code = '' }) {
      const types = {
        add:
          this.$l('INDEX.dialog_title_container_add') ||
          '添加发运单装柜记录信息',
        edit:
          this.$l('INDEX.dialog_title_container_edit') ||
          '编辑发运单装柜记录信息',
        detail:
          this.$l('INDEX.dialog_title_container_view') ||
          '发运单装柜记录信息详情',
      }
      this.editFormDialogOptions = {
        visible: true,
        title: types[type],
        code: code,
        disabled: type === 'detail',
      }
    },
    onLCLConfirm(e) {
      if (!e) return

      this.loadingOpen()
      this.$api
        .shipmentContainerAddApi({ ...e, shipmentCode: this.shipmentCode })
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || res.msg)
            return
          }
          this.$message({
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          this.$refs.lcl.reload()
        })
        .catch(() => {
          this.loadingClose()
        })
    },
  },
}
</script>
<style scoped>
.print_btn_group {
  height: 110px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
</style>
